import _ from 'lodash';
import type { ISetProperty, ISetValuePayload, IWebServiceConfigState, WebServiceActions } from './WebServiceContext';
import { WebServiceActionTypes } from './WebServiceContext';

export const WebServiceReducer = (state: IWebServiceConfigState, action: WebServiceActions): IWebServiceConfigState => {
  switch (action.type) {
    case WebServiceActionTypes.INIT_WEB_SERVICE_CONFIG:
      return {
        ...action.payload
      };
    case WebServiceActionTypes.SET_VALUE:
      return setWebServiceConfig(state, action.payload);
    case WebServiceActionTypes.UNSET_VALUE:
      return unSetWebServiceConfig(state, action.payload);
    case WebServiceActionTypes.SET_PROPERTY:
      return setWebServiceProperty(state, action.payload);
    case WebServiceActionTypes.UNSET_PROPERTY:
      return unSetWebServiceProperty(state, action.payload);
    default:
      return state;
  }
};

const setWebServiceConfig = (state: IWebServiceConfigState, payload: ISetValuePayload) => {
  const stateCopy = _.cloneDeep(state);
  if (payload.value === undefined) {
    _.unset(stateCopy.schema, payload.key);
  } else {
    _.set(stateCopy.schema, payload.key, payload.value);
  }

  return stateCopy;
};

const unSetWebServiceConfig = (state: IWebServiceConfigState, payload: { key: string[] }) => {
  const stateCopy = _.cloneDeep(state);
  _.unset(stateCopy.schema, payload.key);

  return stateCopy;
};

const setWebServiceProperty = (state: IWebServiceConfigState, payload: ISetProperty['payload']) => {
  const stateCopy = _.cloneDeep(state);
  payload.forEach(({ key, value }) => {
    if (value === undefined) {
      _.unset(stateCopy, key);
    } else {
      _.set(stateCopy, key, value);
    }
  });

  return stateCopy;
};

const unSetWebServiceProperty = (state: IWebServiceConfigState, payload: { keys: Array<string[]> }) => {
  const stateCopy = _.cloneDeep(state);
  payload.keys.forEach(key => _.unset(stateCopy, key));

  return stateCopy;
};
